import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { distinctUntilChanged, map } from 'rxjs/operators'
import * as Language from '../utils/language'
import { SupportedLanguage } from '../utils/language'
import { AppConfigService } from './app-config.service'

type I18nConfig = {
  selectedLanguage: SupportedLanguage
}

@Injectable({ providedIn: 'root' })
export class I18nConfigService {
  private _state= new BehaviorSubject<I18nConfig>({ selectedLanguage: Language.resolve() })
  public state$ = this._state.asObservable().pipe(distinctUntilChanged())
  public availableLanguages$ = this.appConfig.state$.pipe(
    map((appConfig)=>appConfig.i18n.availableLanguages),
    distinctUntilChanged()
  )
  public selectedLanguage$ = this.state$.pipe(
    map(({ selectedLanguage })=>selectedLanguage),
    distinctUntilChanged()
  )
  constructor (
    private appConfig: AppConfigService
  ) {}
  public get state (): I18nConfig {
    return this._state.value
  }
  public get selectedLanguage (): string {
    return this._state.value.selectedLanguage
  }
  public selectLanguage (language:string):void {
    if(language === this.selectedLanguage) return
    const validLanguage = Language.parse(language)
    if (validLanguage === null) throw Error(`Invalid language code : ${language}`)
    Language.toLocalStorage(validLanguage)
    window.location.reload()
  }
}
